import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import {
  BalanceOfContractApprovalComponent, BillingDOADashboardComponent,
  PurchaseOfAlarmSystemApprovalComponent
} from '@modules/my-tasks/components/billing/DOA';

const routes: Routes = [
  {
    path: '', component: BillingDOADashboardComponent, data: { title: 'Billing DOA Dashboard' }, canActivate: [AuthGuard]
  },
  {
    path: 'balance-of-contract/approval', component: BalanceOfContractApprovalComponent, data: { title: 'Balance Of Contract Approval' },
    canActivate: [AuthGuard]
  },
  {
    path: 'purchase-of-alarm-system/approval', component: PurchaseOfAlarmSystemApprovalComponent, data: { title: 'Purchase Of Alarm System Approval' },
    canActivate: [AuthGuard]
  }
];
@NgModule({
  declarations: [BillingDOADashboardComponent, BalanceOfContractApprovalComponent, PurchaseOfAlarmSystemApprovalComponent],
  imports: [
    MaterialModule,
    SharedModule,
    RouterModule.forChild(routes)
  ]
})
export class MyTasksBillingDOAModule { }
